<script lang="ts" setup>
import LabelForm from '@/components/labels/LabelForm.vue';
import { UserLabel } from '@/models/label.model';
import { Mutations, ShiftCMSState } from '@/store';
import { LabelsActions, LabelsState } from '@/stores/labels.store';
import { computed, markRaw, onBeforeUnmount, onMounted } from 'vue';
import { useStore } from 'vuex';
import { format } from 'date-fns';

const store = useStore<ShiftCMSState & { ls: LabelsState }>();
const labels = computed<UserLabel[]>(() => store.state.ls.labels);

const update = () => {
  store.dispatch(LabelsActions.GetLabels);
};

onMounted(() => {
  update();
});

onBeforeUnmount(() => {
  store.commit(Mutations.HideDrawer);
});

const editLabel = (_: Event, { item }: { item: UserLabel }) => {
  store.commit(Mutations.ShowDrawer, {
    component: markRaw(LabelForm),
    data: item,
  });
};

const addLabel = () => {
  store.commit(Mutations.ShowDrawer, { component: markRaw(LabelForm) });
};

const headers = [
  { title: 'ID', key: 'id', sortable: false },
  { title: 'Value', key: 'value' },
  { title: 'Date', key: 'creationDate' },
];
</script>

<template>
  <v-container>
    <h2>Labels</h2>

    <v-data-table
      density="compact"
      @click:row="editLabel"
      :headers="headers"
      :items="labels"
      itemsPerPage="25"
      hover
    >
      <template v-slot:item.creationDate="{ value }">
        {{ format(value, 'do MMMM yyyy - HH:mm') }}
      </template>
    </v-data-table>

    <v-btn @click="addLabel" color="success">Add Label</v-btn>
  </v-container>
</template>
